import {UserManager} from '.';
import type {ResetPasswordType, UserInfo} from './FetchDataTypes';

declare const CMS_URL: string;
declare const DID_API_KEY: string;
declare const AUTH0_DOMAIN: string;

const config = {
  BASE_URL: CMS_URL,
};

type ImageResponse = {
  imagesList: [];
  videosList: [];
  url: string;
  id: string;
  Location: string;

  src: {
    formats: {
      thumbnail: { url: string };
      large: { url: string };
    };
    id: string;
    url: string;
  };
};

type TwinGalleryResponse = any[];

type ErrorResponse = {
  url: string;
  id: string;
};

type GenericFunction = (...args: any[]) => any;

const PASSWORD_CONNECTION: string = 'Username-Password-Authentication';

export class FetchData {
  private static jtwToken: string | null;
  private static readonly API_URL_DID = 'https://api.d-id.com/talks';
  private static readonly HEADERS = {
    accept: 'application/json',
    authorization: `Bearer ${localStorage.getItem('jwt')}`,
  };

  private static readonly HEADERS_D_ID = {
    accept: 'application/json',
    //authorization: 'Bearer ' + localStorage.getItem("jwt"),
    authorization: `Basic ${DID_API_KEY}`,
  };

  public static setJWTToken(token: string | null) {
    FetchData.jtwToken = token;
    FetchData.HEADERS.authorization = `Bearer ${token}`;
  }

  // FETCH IMAGES
  public static async fetchImages(): Promise<ImageResponse[]> {
    const response = await fetch(`${config.BASE_URL}api/me/images`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }

    const data = await response.json();
    return data?.data;
  }

  // FETCH IMAGES
  public static async fetchImage(imageID: number): Promise<any> {
    const response = await fetch(`${config.BASE_URL}api/images/${imageID}?populate=*`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }
    return await response.json();
  }
  // FETCH VIDEOS
  public static async fetchVideos(): Promise<any[]> {
    const response = await fetch(FetchData.API_URL_DID, {
      method: 'GET',
      headers: FetchData.HEADERS_D_ID,
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.talks;
  }
  public static async fetchStrapiVideos(): Promise<any[]> {
    const response = await fetch(`${config.BASE_URL}api/me/videos`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data?.data;
  }

  // public static ensureLoggedInFetch(callback: function, ) {

  // }

  // function isLoggedIn(): boolean {
  //   // Placeholder for the actual logic to check if the user is logged in
  //   // Return true if logged in, false otherwise
  //   return true; // Example: assume the user is logged in
  // }

  public static async showLoginPopup(): Promise<void> {
    // Placeholder method to be called if the user is not logged in
    // console.log('User not logged in. Operation aborted.');
    const popup = document.getElementById('register-modal') as HTMLElement;
    if (popup) {
      popup.classList.remove('hide');
      popup.style.display = 'flex';
      popup.style.opacity = '1';
      popup.style.visibility = 'visible';
      const popupClose = popup.querySelector(
        '[cc-element="close-generic-modal"]'
      ) as HTMLAnchorElement;
      popupClose.addEventListener('click', (event) => {
        popup.classList.add('hide');
      });
    } else {
      console.log("Register and login popup doesn't exist");
    }
  }

  public static async callIfLoggedIn(fn: GenericFunction, ...args: any[]): Promise<any> {
    const userManager: UserManager | undefined = await UserManager.getInstance();
    // UserManager.AUTH_STATUS__LOGGED_OUT
    // UserManager.AUTH_STATUS__LOGGED_IN
    // const isLoggedIn = !!localStorage.getItem('jwt');
    console.log(
      '------------------------------------------------------------------------------------------'
    );
    console.log('userManager.status: ', userManager.status);

    if (userManager.status === UserManager.AUTH_STATUS__LOGGED_IN) {
      // User is logged in, call the main function with all its arguments
      return fn(...args);
    }
    // User is not logged in, call the placeholder method
    this.showLoginPopup();
  }

  // Example usage
  // function myFunction(a: number, b: number): number {
  //   console.log(`Performing operation with ${a} and ${b}`);
  //   // Example operation
  //   return a + b;
  // }

  // Example calls
  // console.log(callIfLoggedIn(myFunction, 5, 3)); // Will call myFunction if logged in
  // console.log(callIfLoggedIn(myFunction, 10, 20)); // Will call myFunction if logged in

  // Adjust isLoggedIn function to test behavior when not logged in

  public static async fetchDigitalTwinInfo(
    digitalCloneID: number,
    itRequiresLogged = false
  ): Promise<any> {
    const response = await fetch(`${config.BASE_URL}api/digital-twins/${digitalCloneID}`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }
    return await response.json();
  }

  // FETCH DIGITAL TWIN IMAGE GALLERY
  public static async fetchDigitalTwinImageGallery(digitalCloneID: number): Promise<any> {
    const response = await fetch(
      `${config.BASE_URL}api/digital-twins/${digitalCloneID}?populate=*`,
      {
        method: 'GET',
        headers: FetchData.HEADERS,
      }
    );
    if (!response.ok) {
      throw new Error();
    }
    return await response.json();
  }

  public static async fetchDigitalTwinNormalAndPremiumImageGallery(slug: any): Promise<any> {
    try {
      // FetchData.fetchDigitalTwinImageGallery(slug)
      //   .then((response) => {
      //     console.log('response', response);
      //     return response.data.attributes.premiumImageGallery.data;
      //   })
      const response = await FetchData.fetchDigitalTwinImageGallery(slug);
      console.log('response', response);
      return {
        imageGallery: response.data.attributes.imageGallery.data,
        premiumImageGallery: response.data.attributes.premiumImageGallery.data,
      };
    } catch (error) {
      // @ts-ignore
      console.error('There was a problem with the fetch operation:', error.message);
      // @ts-ignore
      throw new Error(error.message || 'There was a problem with the fetch operation');
    }
  }

  public static async fetchImageGallery(slug: any): Promise<any> {
    try {
      const response = await FetchData.fetchDigitalTwinImageGallery(slug);
      console.log('response', response);
      return response.data.attributes.imageGallery.data;
    } catch (error) {
      // @ts-ignore
      console.error('There was a problem with the fetch operation:', error.message);
      // @ts-ignore
      throw new Error(error.message || 'There was a problem with the fetch operation');
    }
  }

  public static async fetchPremiumImageGallery(slug: any): Promise<any> {
    try {
      const response = await FetchData.fetchDigitalTwinImageGallery(slug);
      console.log('response', response);
      return response.data.attributes.premiumImageGallery.data;
    } catch (error) {
      // @ts-ignore
      console.error('There was a problem with the fetch operation:', error.message);
      // @ts-ignore
      throw new Error(error.message || 'There was a problem with the fetch operation');
    }
  }

  // DELETE A VIDEO
  public static async deleteVideoDID(id: string): Promise<any[]> {
    const response = await fetch(`https://api.d-id.com/talks/${id}`, {
      method: 'DELETE',
      headers: {
        ...FetchData.HEADERS_D_ID,
      },
    });
    const data = await response.json(); // Parse the response body here
    if (!response.ok) {
      throw new Error(data.description || 'Network response was not ok');
    }
    return await data;
  }

  // DELETE A IMAGE
  public static async deleteImage(id: string): Promise<any[]> {
    const requestOptions: RequestInit = {
      method: 'PUT',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
    };

    return fetch(`${config.BASE_URL}api/me/setDeletedImage/${id}`, requestOptions).then(
      async (response) => {
        const data = await response.text(); // temporarily use .text() to see the raw content

        try {
          // Try to parse as JSON
          const jsonData = JSON.parse(data);
          if (!response.ok) {
            throw new Error(jsonData.description || 'Network response was not ok');
          }
          return jsonData;
        } catch (error) {
          // If it's not JSON, just propagate the error or the text data
          throw new Error(data || 'Network error');
        }
      }
    );
  }

  // DELETE A IMAGE
  public static async setCloneAvatar(
    imageID: string,
    identityId: number,
    digitalCloneID: number
  ): Promise<any[]> {
    const requestOptions: RequestInit = {
      method: 'PUT',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        digitalCloneId: digitalCloneID,
        avatarId: imageID,
        identityId: identityId,
      }),
    };

    const response = await fetch(
      `${config.BASE_URL}api/digital-twins/setAvatarAndIdentity`,
      requestOptions
    );
    const data_1 = await response.text(); // temporarily use .text() to see the raw content
    try {
      // Try to parse as JSON
      const jsonData = JSON.parse(data_1);
      if (!response.ok) {
        throw new Error(jsonData.description || 'Network response was not ok');
      }
      return jsonData;
    } catch (error) {
      // If it's not JSON, just propagate the error or the text data
      throw new Error(data_1 || 'Network error');
    }
  }

  public static async setActiveVoiceClone(
    voiceCloneId: string,
    digitalCloneID: number
  ): Promise<any[]> {
    const requestOptions: RequestInit = {
      method: 'PUT',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        digitalCloneId: digitalCloneID,
        voiceCloneId: voiceCloneId,
      }),
    };

    const response = await fetch(`${config.BASE_URL}api/setActiveVoiceClone`, requestOptions);
    const data_1 = await response.text(); // temporarily use .text() to see the raw content
    try {
      // Try to parse as JSON
      const jsonData = JSON.parse(data_1);
      if (!response.ok) {
        throw new Error(jsonData.description || 'Network response was not ok');
      }
      return jsonData;
    } catch (error) {
      // If it's not JSON, just propagate the error or the text data
      throw new Error(data_1 || 'Network error');
    }
  }

  // DELETE A IMAGE
  public static async deleteVideo(id: string): Promise<any[]> {
    const requestOptions: RequestInit = {
      method: 'PUT',

      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
    };

    const response = await fetch(
      //api/images/1
      // `${config.BASE_URL}api/videos/${id}`,
      `${config.BASE_URL}api/me/setDeletedVideo/${id}`,
      requestOptions
    );
    const data = await response.text(); // temporarily use .text() to see the raw content
    try {
      // Try to parse as JSON
      const jsonData = JSON.parse(data);
      if (!response.ok) {
        throw new Error(jsonData.description || 'Network response was not ok');
      }
      return jsonData;
    } catch (error) {
      // If it's not JSON, just propagate the error or the text data
      throw new Error(data || 'Network error');
    }
  }

  public static async fetchChatTraining(_user: number): Promise<any> {
    const data = {
      data: {
        users: _user,
        type: 'harvester',
        username: 'Andreas',
      },
    };

    try {
      const response = await fetch(`${config.BASE_URL}api/clone-instances/`, {
        method: 'POST',
        headers: {
          ...FetchData.HEADERS,
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(data),
      });
      const result_1 = await response.json();
      console.log('Reply from clone-instances', result_1);
      return result_1;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async uploadImage(input: HTMLInputElement): Promise<ImageResponse> {
    console.log('input', input);

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const form = new FormData();

      form.append('files.src', file, file.name);
      const data = {
        user: 6,
        extId: 'test',
      };
      form.append('data', JSON.stringify(data));
      console.log('UPLOAD IMAGE DATA', data);
      // Return the fetch promise here
      return fetch(`${config.BASE_URL}api/images?populate=*`, {
        method: 'POST',
        headers: FetchData.HEADERS,
        body: form,
        redirect: 'follow',
      })
        .then((response) => response.json()) // assuming the response should be JSON
        .then((result) => {
          console.log('UPLOAD RESULT', result);
          return result;
        })
        .catch((error) => {
          console.log('UPLOAD ERROR', error);
          throw error; // propagate the error so that the caller knows about it
        });
    }
    return Promise.reject('No file selected'); // using Promise.reject for brevity
  }

  public static async sendPasswordUpdateEmail(
    resetPasswordInfo: ResetPasswordType
  ): Promise<string> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const body = JSON.stringify({
      client_id: resetPasswordInfo.clientId,
      email: resetPasswordInfo.email,
      connection: PASSWORD_CONNECTION,
    });

    const requestOptions: RequestInit = {
      method: 'POST',
      headers: headers,
      body,
    };

    fetch(`${AUTH0_DOMAIN}/dbconnections/change_password`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        return result;
      })
      .catch((error) => {
        throw error;
      });
    return Promise.reject("There's been an error processing your request");
  }

  public static async uploadImageTwinGallery(
    file: File,
    digitalCloneID: number
  ): Promise<TwinGalleryResponse> {
    if (file !== null) {
      const form = new FormData();
      // form.append('files.src', file, file.name);
      form.append('files', file);
      form.append('ref', 'api::digital-twin.digital-twin');
      form.append('refId', digitalCloneID.toString());
      form.append('field', 'imageGallery');

      const data = {
        user: 6,
        extId: 'test',
      };
      // form.append('data', JSON.stringify(data));
      console.log('UPLOAD IMAGE DATA', data);
      // Return the fetch promise here
      return fetch(`${config.BASE_URL}api/upload`, {
        method: 'post',
        headers: FetchData.HEADERS,
        body: form,
        redirect: 'follow',
      })
        .then((response) => response.json()) // assuming the response should be JSON
        .then((result) => {
          console.log('UPLOAD RESULT', result);
          return result;
        })
        .catch((error) => {
          console.log('UPLOAD ERROR', error);
          throw error; // propagate the error so that the caller knows about it
        });
    }
    return Promise.reject('No file selected'); // using Promise.reject for brevity
  }

  // DELETE A IMAGE FROM TWIN GALLERY
  public static async deleteImageTwinGallery(
    imageID: number,
    digitalCloneID: number
  ): Promise<ImageResponse> {
    const form = new FormData();
    form.append('refId', digitalCloneID.toString());

    return fetch(`${config.BASE_URL}api/upload/files/${imageID}`, {
      method: 'DELETE',
      headers: FetchData.HEADERS,
      body: form,
    })
      .then(async (response) => {
        console.log('DELETE IMAGE RESPONSE', response);

        return response.json();
      })
      .catch((error) => {
        console.log('DELETE IMAGE ERROR', error);
        throw error;
      });
  }

  //
  public static async uploadVideoToStrapi(
    _src: string,
    _videoID: string,
    _image: string
  ): Promise<ImageResponse> {
    //if (input.files && input.files.length > 0) {
    //const file = input.files[0];
    const form = new FormData();

    const data = {
      // user: memberID,
      extId: _image,
      src: _src,
      image: parseInt(_image),
    };

    form.append('data', JSON.stringify(data));

    // Return the fetch promise here
    return fetch(`${config.BASE_URL}api/videos?populate=*`, {
      method: 'POST',
      headers: FetchData.HEADERS,
      body: form,
      redirect: 'follow',
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        console.log('UPLOAD RESULT', result);
        return result;
      })
      .catch((error) => {
        console.log('UPLOAD ERROR', error);
        throw error; // propagate the error so that the caller knows about it
      });
  }

  // CREATE A CLONE
  public static async createClone(
    imageURL: string,
    input: string,
    imageID: string
  ): Promise<any[]> {
    return fetch('https://api.d-id.com/talks', {
      method: 'POST',
      headers: {
        ...FetchData.HEADERS_D_ID,
        accept: 'application/json',
        'content-type': 'application/json',
      },

      body: JSON.stringify({
        script: {
          type: 'text',
          subtitles: 'false',
          provider: { type: 'microsoft', voice_id: 'en-US-JennyNeural' },
          ssml: false,
          input: input,
        },
        name: imageID,
        // webhook: 'https://cloneme-preregister-v2.webflow.io/dev',
        config: {
          fluent: 'false',
          pad_audio: '0.0',
          stitch: 'true',
          driver_expressions: {
            expressions: [
              {
                start_frame: 0,
                expression: 'neutral',
                intensity: 1,
              },
            ],
          },
        },
        source_url: imageURL, // Adjust this based on what your endpoint expects
      }),
    })
      .then(async (response) => {
        const data = await response.json(); // Parse the response body here

        if (!response.ok) {
          throw new Error(data.description || 'Network response was not ok');
        }
        return data;
      })
      .then((data) => {
        console.log('createClone', data);
        return data.talks;
      });
  }

  public static async fetchUser(): Promise<any> {
    const endpoint = window.project?`${config.BASE_URL}api/${window.project}/me/info`:`${config.BASE_URL}api/me/info`
    return fetch(endpoint, {
      method: 'GET',
      headers: FetchData.HEADERS,
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem('jwt');
          localStorage.removeItem('auth0_jwt');
          return null;
        }
        if (!response.ok && response.headers && response.headers.get('x-redirect')) {
          window.location.href = response.headers.get('x-redirect');
          return null;
        }
        return response.json();
      })
      .then((result) => {
        console.log('fetchUser', result);
        return result;
      })
      .catch((error) => {
        throw error;
      });
  }

  public static async updateIdentity(_field: string, _value: string, _id: number): Promise<any> {
    console.log('updateTwin', _field, _value);

    // Parameter validation
    if (!_field || !_value) {
      throw new Error('Invalid parameters');
    }

    try {
      const response = await fetch(`${config.BASE_URL}api/identities/${_id}`, {
        method: 'PUT',
        headers: {
          ...FetchData.HEADERS,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            [_field]: _value,
          },
        }),
      });

      const result = await response.json();

      return result;
    } catch (error) {
      console.error('Error updating twin:', error); // More specific error logging
      throw error; // Rethrow the error if you want the caller to handle it
    }
  }

  public static async updateTwin(_field: string, _value: string, _id: number): Promise<any> {
    console.log('updateTwin', _field, _value);

    // Parameter validation
    if (!_field || !_value) {
      throw new Error('Invalid parameters');
    }

    try {
      const response = await fetch(`${config.BASE_URL}api/digital-twins/${_id}`, {
        method: 'PUT',
        headers: {
          ...FetchData.HEADERS,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            [_field]: _value,
          },
        }),
      });

      const result = await response.json();

      return result;
    } catch (error) {
      console.error('Error updating twin:', error); // More specific error logging
      throw error; // Rethrow the error if you want the caller to handle it
    }
  }

  public static async fetchUserByMemberstackID(_MemberStackid: string): Promise<any> {
    // Return the fetch promise here
    return fetch(`${config.BASE_URL}api/users?filters[memberstackId][$eq]=${_MemberStackid}`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        // console.log('UPLOAD ERROR', error);
        throw error; // propagate the error so that the caller knows about it
      });
  }
  public static async fetchUserByMemberstackID_prod(_MemberStackid: string): Promise<any> {
    // Return the fetch promise here
    return fetch(
      `${config.BASE_URL}api/users?populate[digital_clone][populate][0]=avatar,influencer&filters[memberstackId][$eq]=${_MemberStackid}`,
      {
        method: 'GET',
        headers: FetchData.HEADERS,
      }
    )
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        // console.log('UPLOAD ERROR', error);
        throw error; // propagate the error so that the caller knows about it
      });
  }
  public static async fetchGetInfluencers(): Promise<any> {
    // Return the fetch promise here
    return fetch(`https://cloneme-backend-prod-b7c55e1be764.herokuapp.com/api/influencers`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        console.log('fetchGetInfluencers', result);
        return result;
      })
      .catch((error) => {
        // console.log('UPLOAD ERROR', error);
        throw error; // propagate the error so that the caller knows about it
      });
  }
  public static async fetchInfluencerChat(_userID: string, influencerID: string): Promise<any> {
    const data = {
      data: {
        users: Number(_userID),
        type: 'conversational',
        influencer: Number(influencerID),
      },
    };
    console.log('fetchInfluencerChat DATA', data);
    return fetch(`${config.BASE_URL}api/clone-instances`, {
      method: 'POST',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },

      body: JSON.stringify(data),
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error; // propagate the error so that the caller knows about it
      });
  }
  public static async getCloneVideo(_endpoint: string): Promise<any[]> {
    const response = await fetch(`${config.BASE_URL}api/me/videos/${_endpoint}`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }
    const data = await response.json();
    return data?.data;
  }
  public static async getVoiceCloneVideo(): Promise<any[]> {
    const response = await fetch(`${config.BASE_URL}api/me/videos/digitalTwinVoiceClone`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }
    const data = await response.json();
    return data?.data;
  }
  public static async saveCloneVideo(_data: any, _endpoint: string): Promise<any> {
    const formdata = new FormData();
    formdata.append('data', JSON.stringify(_data));
    const requestOptions = {
      method: 'POST',
      headers: FetchData.HEADERS,
      body: formdata,
    };

    try {
      const response = await fetch(`${config.BASE_URL}api/me/videos/${_endpoint}`, requestOptions);
      const result = await response.json();
      console.log('saveVideo', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }
  public static async saveVoiceCloneVideo(_data: any): Promise<any> {
    const formdata = new FormData();
    formdata.append('data', JSON.stringify(_data));
    const requestOptions = {
      method: 'POST',
      headers: FetchData.HEADERS,
      body: formdata,
    };

    try {
      const response = await fetch(
        `${config.BASE_URL}api/me/videos/digitalTwinVoiceClone`,
        requestOptions
      );
      const result = await response.json();
      console.log('saveVideo', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }
  public static async getTwinIdentityVideo(): Promise<any[]> {
    const response = await fetch(`${config.BASE_URL}api/me/videos/digitalTwinIdentity`, {
      method: 'GET',
      headers: FetchData.HEADERS,
    });
    if (!response.ok) {
    }
    const data = await response.json();
    return data?.data;
  }

  public static async saveTwinIdentityVideo(_data: any): Promise<any> {
    const formdata = new FormData();
    formdata.append('data', JSON.stringify(_data));
    const requestOptions = {
      method: 'POST',
      headers: FetchData.HEADERS,
      body: formdata,
    };

    try {
      const response = await fetch(
        `${config.BASE_URL}api/me/videos/digitalTwinIdentity`,
        requestOptions
      );
      const result = await response.json();
      console.log('saveVideo', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async getSubscriptions(): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: FetchData.HEADERS,
    };

    try {
      const response = await fetch(`${config.BASE_URL}api/subscriptions/list`, requestOptions);
      const result = await response.json();
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async getStripeRedirectUrl(
    productId: string,
    callback: string,
    cancelCallback: string,
    source: string
  ): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: FetchData.HEADERS,
    };

    try {
      const response = await fetch(
        `${config.BASE_URL}api/stripe/get/${productId}?callback=${callback}&cancelCallback=${cancelCallback}&source=${source}`,
        requestOptions
      );
      const result = await response.json();
      //console.log('Stripe Redirect URL', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async getStripeBillingSession(callback: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: FetchData.HEADERS,
    };

    try {
      const response = await fetch(
        `${config.BASE_URL}api/stripe/billingSession?callback=${callback}`,
        requestOptions
      );
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }

  public static async cancelSubscription(): Promise<any> {
    try {
      const response = await fetch(
        `${config.BASE_URL}api/k-store-ecsuite/subscriptions/cancel-active`,
        {
          method: 'POST',
          headers: FetchData.HEADERS,
        }
      );
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  public static async isSubscribedToTwin(twinId: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: FetchData.HEADERS,
    };
    try {
      const response = await fetch(
        `${config.BASE_URL}api/me/twinSubscriptions/isSubscribedS/${twinId}`,
        requestOptions
      );
      const result = await response.json();
      console.log('is subscribe', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async subscribeToTwin(twinId: string): Promise<any> {
    const requestOptions = {
      method: 'POST',
      headers: FetchData.HEADERS,
    };
    try {
      const response = await fetch(
        `${config.BASE_URL}api/me/twinSubscriptions/subscribeS/${twinId}`,
        requestOptions
      );
      const result = await response.json();
      console.log('subscribe', result);
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async fetchUserWallet(isExtended: boolean = false): Promise<any> {
    const extraParam = isExtended?"&extender=1":"";
    try {
      const response = await fetch(`${config.BASE_URL}api/me/wallet${extraParam}`, {
        method: 'GET',
        headers: FetchData.HEADERS,
      });
      const result = await response.json();
      return result;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async fetchStripeSession(sessionId: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: FetchData.HEADERS,
    };
    try {
      const response = await fetch(
        `${config.BASE_URL}api/stripe/retrieveCheckoutSession/${sessionId}`,
        {
          method: 'GET',
          headers: FetchData.HEADERS,
        }
      );
      return response;
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async updateUserProfile(userInfo: UserInfo): Promise<any[]> {
    const requestOptions: RequestInit = {
      method: 'PUT',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        tiktokHandle: userInfo.tiktokHandle || undefined,
        instagramHandle: userInfo.instagramHandle || undefined,
        onlyFansHandle: userInfo.onlyFansHandle || undefined,
        xHandle: userInfo.xHandle || undefined,
        mobileNumber: userInfo.mobileNumber || undefined,
        message: userInfo.message || undefined,
      }),
    };

    const response = await fetch(`${config.BASE_URL}api/me/info`, requestOptions);
    const data_1 = await response.text(); // temporarily use .text() to see the raw content
    try {
      const jsonData = JSON.parse(data_1);
      if (!response.ok) {
        throw new Error(jsonData.description || 'Network response was not ok');
      }
      return jsonData;
    } catch (error) {
      // If it's not JSON, just propagate the error or the text data
      throw new Error(data_1 || 'Network error');
    }
  }

  public static async setLocalstorageLoginParamsAfterRedirect(): Promise<void> {
    try {
      await fetch(`${config.BASE_URL}api/auth/auth0/callback${window.location.search}`)
        .then((res) => {
          if (res.status !== 200) {
            throw new Error(`Couldn't login to Strapi. Status: ${res.status}`);
          }
          return res;
        })
        .then((res) => res.json())
        .then((res) => {
          console.log('res', res);
          // Successfully logged with Strapi
          // Now saving the jwt to use it for future authenticated requests to Strapi
          localStorage.setItem('jwt', res.jwt);
          localStorage.setItem('username', res.user.username);
          localStorage.setItem(
            'auth0_jwt',
            new URLSearchParams(window.location.search).get('id_token') || ''
          );
        })
        .catch((err) => {
          console.log('error: ', err);
          throw new Error(err);
          //setText("An error occurred, please see the developer console.");
        });
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async getClientChatSession(digitalTwin: string): Promise<any> {
    return fetch(`${config.BASE_URL}api/getTwinClientSessionS/${digitalTwin}`, {
      method: 'GET',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) return null;
        return response.json();
      })
      .then((result) => {
        return result?.data?.attributes?.url ?? null;
      })
      .catch((error) => {
        throw error;
      });
  }

  public static async sendConfirmationEmail(): Promise<any> {
    return fetch(`${config.BASE_URL}api/auth/send-email-confirmation`, {
      method: 'POST',
      headers: {
        ...FetchData.HEADERS,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error; // propagate the error so that the caller knows about it
      });
  }

  public static async loginRedirect(params: string): Promise<any> {
    return fetch(`${config.BASE_URL}api/auth/auth0/callback${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error; // propagate the error so that the caller knows about it
      });
  }

  public static async login(params: string): Promise<any> {
    return fetch(`${config.BASE_URL}api/connect/auth0?callback=${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json()) // assuming the response should be JSON
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error; // propagate the error so that the caller knows about it
      });
  }

  public static async createChatSession(twinUUID:string): Promise<any> {
    const data = {
      data: {
        uuid: twinUUID
      },
    };

    try {
      const response = await fetch(`${config.BASE_URL}api/${window.project}/sessions`, {
        method: 'POST',
        headers: {
          ...FetchData.HEADERS,
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      throw error; // propagate the error so that the caller knows about it
    }
  }

  public static async createAnonChatSession(twinUUID: string, browserId: string): Promise<any> {
    const data = { data: { uuid: twinUUID, browserId } };
    try {
      const response = await fetch(`${config.BASE_URL}api/${window.project}/sessions/anon`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}
